
import { DvlaLookupSettingsComponent } from './dvla-lookup.settings.component';
import { SessionService }              from '../sessions/session.service';

export const DVLALookupStates : Array<any> = [
  {
    component: DvlaLookupSettingsComponent,
    name     : 'app.dvla-lookup',
    url      : '/dvla_lookup',
    resolve  : [
      {
        token    : 'refresh',
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<any> => sessionService.refresh()
      }
    ]
  }
];
